import React, { FunctionComponent, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import 'moment-timezone'
import { colors } from 'Styled/variables'
import { CampaignStatus } from 'Constants/enums'
import { formatDate } from 'Constants/formatDate'
import { IconTikTok, IconDefaultCover } from 'Stories/Icon/Icon.stories'
import Title from '../../../../Components/Title'
import { DetailsCardProps } from './DetailsCardProps'

import {
  StyledDetailsCard,
  StyledIcon,
  ImgWrapper,
  IconWrapper,
  NamesWrapper,
  Name,
  Artist,
  Img,
  BudgetWrapper,
  Row,
  Key,
  Value,
  StatusWrapper,
  Status,
  Completed,
  StyledProgress,
  DataCollection,
  Orange,
  Small,
} from './styles'

const DetailsCard: FunctionComponent<DetailsCardProps> = ({
  campaignDetails,
}) => {
  const { t } = useTranslation()
  const CAMPAIGN_PERIOD = 14
  const nowDate = new Date()
  const daysLeft = useMemo(
    () => moment(campaignDetails?.endDate).diff(moment(nowDate), 'days') || 0,
    [campaignDetails]
  )

  const persentageGraph = (daysLeft * 100) / CAMPAIGN_PERIOD
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return (
    <StyledDetailsCard>
      <StyledIcon>
        <ImgWrapper>
          {campaignDetails?.trackCoverUrl ? (
            <Img alt="" src={campaignDetails.trackCoverUrl} />
          ) : (
            <IconDefaultCover />
          )}
        </ImgWrapper>

        <IconWrapper>
          <IconTikTok />
        </IconWrapper>
      </StyledIcon>

      <NamesWrapper>
        <Name>
          <Title title={t('campaignsPage.trackName')} />
          {campaignDetails?.trackTitle}
        </Name>

        <Artist>
          <Title title={t('campaignsPage.artist')} />
          {campaignDetails?.trackAutorName}
        </Artist>
      </NamesWrapper>

      <BudgetWrapper>
        <Row>
          <Key>{t('campaignResultsPage.budgetLabel')}:</Key>
          <Value>&#36;{campaignDetails?.amount || 0}</Value>
        </Row>

        <Row>
          <Key>{t('campaignResultsPage.estimate')}:</Key>
          <Value>
            {campaignDetails?.expectedMinVideos || 0}-
            {campaignDetails?.expectedMaxVideos || 0}&nbsp;
            {t('campaignResultsPage.videos')}
          </Value>
        </Row>
        {campaignDetails?.status ===
          (CampaignStatus.ENDED && CampaignStatus.FINISHED) && (
          <Row>
            <Key>{t('campaignResultsPage.refundLabel')}:</Key>

            <Value refund>&#36;{campaignDetails?.refund}</Value>
          </Row>
        )}
      </BudgetWrapper>

      {campaignDetails?.status ===
      (CampaignStatus.ENDED &&
        CampaignStatus.FINISHED &&
        CampaignStatus.RUNNING &&
        CampaignStatus.INPROCESS) ? (
        <StatusWrapper>
          <Title title={t('campaignsPage.status')} />
          <Status>{t('campaignsPage.ended')}</Status>
          <Completed>
            {campaignDetails?.totalVideos}/{campaignDetails?.totalViews}
            &nbsp;
            {t('campaignResultsPage.completed')}
          </Completed>
        </StatusWrapper>
      ) : (
        <StatusWrapper>
          <Title title={t('campaignsPage.timePeriod')} />
          {moment
            .tz(campaignDetails?.startDate, timezone)
            .format(formatDate.formatDateMonthFirst)}
          ,&nbsp;{daysLeft > 0 ? daysLeft : 0}&nbsp;
          {daysLeft === 1
            ? t('campaignsPage.dayLeft')
            : t('campaignsPage.daysLeft')}
          &nbsp;
          <br />
          <StyledProgress
            percent={persentageGraph}
            steps={14}
            width={176}
            strokeWidth={4}
            showInfo={false}
            strokeColor={daysLeft >= 4 ? colors.green : colors.messegesYellow1}
            trailColor={colors.greyTextBlackBg}
            status="active"
          />
        </StatusWrapper>
      )}

      <DataCollection>
        {campaignDetails?.status === CampaignStatus.ENDED ||
        campaignDetails?.status === CampaignStatus.FINISHED ? (
          <Orange>{t('campaignResultsPage.dataCollectionComplete')}</Orange>
        ) : (
          <Orange>{t('campaignResultsPage.dataCollection')}</Orange>
        )}

        {campaignDetails?.status ===
          (CampaignStatus.ENDED && CampaignStatus.FINISHED) && (
          <Small>{t('campaignResultsPage.campaignDataWillBeUpdated')}</Small>
        )}
      </DataCollection>
    </StyledDetailsCard>
  )
}

export default DetailsCard
